export const GET_ORGS = 'get_organizations';
export const RESET_ORGS = 'reset_organizations';
export const GET_ORG_PROFILE = 'get_organization_profile';
export const RESET_ORG_PROFILE = 'reset_organization_profile';
export const DELETE_ORG_PROFILE = 'delete_organization_profile';
export const EDIT_ORG_PROFILE = 'edit_organization_profile';
export const ADD_ORG = 'add_organization';
